import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Vision from "./pages/Vision";
import Immobili from "./pages/Immobili";
import ImmobileDettaglio from "./pages/ImmobileDettaglio";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminImmobili from "./pages/AdminImmobili";
import AdminContatti from "./pages/AdminContatti";
import TestImageLoad from "./components/TestImageLoad";
import Header from "./components/Header";
import Footer from "./components/Footer";

function Layout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isTestRoute = location.pathname === '/test-image';

  return (
    <>
      {!isAdminRoute && !isTestRoute && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/immobili" element={<Immobili />} />
        <Route path="/immobili/:id" element={<ImmobileDettaglio />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/properties" element={<AdminImmobili />} />
        <Route path="/admin/contacts" element={<AdminContatti />} />
        <Route path="/test-image" element={<TestImageLoad />} />
      </Routes>
      {!isAdminRoute && !isTestRoute && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </div>
  );
}

export default App;
